import { FilestoreAPI } from '@builddocs/filestore-api'
import qs from 'qs'

import { DocstoreSectionEntity } from '../types'

export interface GetDocstoreSectionRequest {
  section: string
  params: {
    pageNumber: number
    pageSize: number
    projectId: string | null
    showDeleted?: boolean
    sortField?: string
    sortDirection?: string
    searchValue?: string
    exactMatch?: boolean
    ownerOrganization?: Array<string>
    ownerUserId?: Array<string>
    cipher?: string
  }
}

export interface GetDocstoreSectionResponse {
  entityList: DocstoreSectionEntity[]
  pageCount: number
  pageNumber: number
  pageSize: number
}

export function getDocstoreSection({
  section,
  params,
}: GetDocstoreSectionRequest) {
  return section === 'executivedrawing'
    ? FilestoreAPI.post<GetDocstoreSectionResponse>(
        `/${section.toLowerCase().replace('_', '')}/search`,
        {
          ...params,
          sortDirection: undefined,
          direction: params.sortDirection,
        },
      ).then(r => r.data)
    : FilestoreAPI.get<GetDocstoreSectionResponse>(
        `/${section.toLowerCase().replace('_', '')}`,
        {
          params: params,
          paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'repeat' })
          },
        },
      ).then(r => r.data)
}
